export default class ClickReadMore {
	constructor(options = {}) {
		this.wrap = options.wrap || null; // 親要素
		this.btn = options.btn || null; // ボタン
		this.btnParent = this.btn ? this.btn.closest(options.btnParentSelector || '') : null; // ボタンの親要素
		this.list = this.wrap ? this.wrap.querySelector(options.listSelector || '') : null; // 表示する要素の親要素
		this.defaultNum = options.defaultNum || 5; // 初期表示数
		this.contents = this.list ? Array.from(this.list.children) : []; // 表示する要素
		this.num = options.num !== undefined ? options.num : null; // 一度に表示する数
		this.classToAdd = this.list ? this.list.getAttribute(options.addClassSelector || '') || options.defaultClassToAdd || '' : options.defaultClassToAdd || ''; // 追加するクラス
		this.btnParentClassToAdd = this.btnParent ? this.btnParent.getAttribute(options.btnParentAddClassSelector || '') || options.defaultClassToAdd || '' : options.defaultClassToAdd || ''; // ボタンの親要素に追加するクラス
		this.hiddenContentsCount = this.contents.length; // 非表示の要素の数
		if (this.btn && this.list) { // ボタンと表示する要素がある場合
			this.init();
		}
	}

	// 初期化
	init() {
		this.initialShow(); // 初期表示
		if (this.btnParent && this.btnParentClassToAdd) { // ボタンの親要素に追加するクラスがある場合
			if (this.contents.length > this.defaultNum) { // 表示する要素の数が初期表示数より多い場合
				this.btnParent.classList.add(this.btnParentClassToAdd); // ボタンの親要素にクラスを追加
			} else { // 表示する要素の数が初期表示数以下の場合
				this.btnParent.classList.remove(this.btnParentClassToAdd); // ボタンの親要素からクラスを削除
			}
		}
		this.btn.addEventListener('click', () => this.show()); // ボタンをクリックした時の処理
	}

	// 初期表示
	initialShow() {
		const initialContents = this.num !== null ? this.contents.slice(0, this.num) : this.contents.slice(0, this.defaultNum); // 初期表示する要素
		initialContents.forEach(content => content.classList.add(this.classToAdd)); // 初期表示する要素にクラスを追加
	}

	// 表示
	show() {
		const hiddenContents = this.contents.filter(content => !content.classList.contains(this.classToAdd)); // 非表示の要素
		const showNow = this.num !== null ? hiddenContents.slice(0, this.num) : hiddenContents; // 一度に表示する要素
		showNow.forEach(content => content.classList.add(this.classToAdd)); // 一度に表示する要素にクラスを追加

		if (!this.contents.some(content => !content.classList.contains(this.classToAdd))) { // 全ての要素が表示された場合
			if (this.btnParent && this.btnParentClassToAdd) { // ボタンの親要素に追加するクラスがある場合
				this.btnParent.classList.remove(this.btnParentClassToAdd); // ボタンの親要素からクラスを削除
			}
		}
	}
}